import { useRef, useState } from 'react';
import { useBeforeUnload, useBlocker } from 'react-router';

import { useI18n } from '#/i18n/hooks/useI18n';
import { ConfirmationModal } from '#/modals/Confirmation/ConfirmationModal';

type Props = {
  shouldBlock: () => boolean;
};

export function NavigationBlocker({ shouldBlock: originalShouldBlock }: Props) {
  const { i18n } = useI18n();
  const [modalSubmitting, setModalSubmitting] = useState(false);

  // In RSC we need a ref to let shouldBlock know that blocking already happened,
  // otherwise it blocks any navigation after the user left the page
  const didBlockRef = useRef(false);
  const shouldBlock = () => !didBlockRef.current && originalShouldBlock();

  const blocker = useBlocker(shouldBlock);
  useBeforeUnload((e: BeforeUnloadEvent) => {
    if (shouldBlock()) {
      e.preventDefault();
    }
  });

  if (blocker.state === 'blocked') {
    return (
      <ConfirmationModal
        qaId="form-navigation-warning-modal"
        type="warning"
        title={i18n(
          'Do you want to navigate away? All unsaved data will be lost.',
        )}
        buttonText={i18n('Leave Page')}
        submitting={modalSubmitting}
        confirm={() => {
          didBlockRef.current = true;
          blocker.proceed();
          setModalSubmitting(true);
        }}
        cancel={() => {
          blocker.reset();
          setModalSubmitting(false);
        }}
      />
    );
  }

  return null;
}
